import React from 'react';
import './CheckboxGroup.css';
interface CheckboxOption {
  value: string;
  label: string;
}
interface CheckboxGroupProps {
  options: CheckboxOption[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  error?: boolean;
  className?: string;
  readOnly?: boolean;
}
const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  options,
  selectedValues,
  onChange,
  error,
  className = '',
  readOnly = false
}) => {
  const handleChange = (value: string, checked: boolean) => {
    if (readOnly) return;
    // Asegurarse de que selectedValues sea un array
    const currentValues = Array.isArray(selectedValues) ? selectedValues : [];
    if (checked) {
      onChange([...currentValues, value]);
    } else {
      onChange(currentValues.filter(v => v !== value));
    }
  };
  return (
    <div className={`checkbox-group ${error ? 'error' : ''} ${className}`}>
      {options.map((option) => (
        <label key={option.value} className="checkbox-item">
          <input
            type="checkbox"
            checked={selectedValues.includes(option.value)}
            onChange={(e) => handleChange(option.value, e.target.checked)}
            disabled={readOnly}
          />
          <span className="checkbox-label">{option.label}</span>
        </label>
      ))}
    </div>
  );
};
export default CheckboxGroup;